import React from 'react';
import cn from 'classnames';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { MainLayout } from '../../../../components/MainLayout';
import DataTable from '../../../../components/shared/DataTable/DataTable';
import { PagesHeader } from '../../../../components/shared/PagesHeader';
import { PERMISSIONS } from '../../../../helpers/auth';
import { useAuthentication } from '../../../../hooks/useAuthentication';
import { COLUMNS, ROUTES, SEARCH_CONFIG } from './FailuresList.config';
import styles from './FailuresList.styles.scss';
import { getAssetUrl } from '../../../../services/apis';
import { showToast } from '../../../../helpers/showToast';

const FailuresList = ({
  renderedFailures,
  originalFailures,
  setFailuresList,
  tableLoading,
}) => {
  const { t } = useTranslation();
  const { hasRole } = useAuthentication();
  const navigate = useNavigate();
  const [isDownloading, setIsDownloading] = React.useState(false);

  const handleDownloadManual = async () => {
    setIsDownloading(true);
    try {
      const response = await getAssetUrl('raseed-user-manual-clean');
      const { url } = response.data;

      if (url) {
        window.open(url, '_blank');
      }
    } catch (error) {
      showToast({
        data: {
          type: 'error',
          message: t('failure_guidelines_failed'),
        },
      });
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <MainLayout eInvoicing={true}>
      <PagesHeader
        withBreadcrumb={true}
        title={t('failure_notification_title')}
        routes={ROUTES}
        wrapperClassName={'mb-0'}
        withActionButton={true}
      />
      <p className={cn('mt-4 mb-4', styles.headerDesc)}>
        {t('failure_notification.list_of_reported_failures_desc')}
      </p>
      <p className="mb-4">
        {t('failure_notification.more_guidelines')}{' '}
        <Button
          link
          text
          className={cn(styles.download, 'px-0 py-0')}
          onClick={handleDownloadManual}
          disabled={isDownloading}
          label={t('common.here')}
        />
      </p>
      <div className={cn(styles.failureListTable, 'mt-3')}>
        <div className="d-flex gap-3 justify-content-end mb-3">
          {hasRole(PERMISSIONS.REPORT_FAILURE) && (
            <Button
              className="px-4"
              label={t('failure_notification.report_technical_failure')}
              disabled={!hasRole(PERMISSIONS.REPORT_FAILURE)}
              onClick={() => navigate('report')}
            />
          )}
        </div>
        <DataTable
          loading={tableLoading}
          value={renderedFailures}
          size="small"
          filterDisplay="menu"
          showSortInFilters={true}
          columns={() => COLUMNS({ t, navigate, hasRole })}
          dataKey="failureReferenceNumber"
          searchConfig={SEARCH_CONFIG}
          searchFields={[
            'failureReferenceNumber',
            'technicalFailureType',
            'solutionProviderName',
          ]}
        />
      </div>
    </MainLayout>
  );
};

export default FailuresList;
